// Supreme Hospitality Solutions - Mock Data

export const companyInfo = {
  name: "Supreme Hospitality Solutions",
  tagline: "Elevating Your Guest Experience",
  description: "Australia's premier hotel housekeeping and hospitality staffing specialists. We deliver immaculate room presentation and exceptional service through our professionally trained housekeeping teams.",
  logo: "https://customer-assets.emergentagent.com/job_c12dcee6-cb25-472a-a8d9-3fec8b95d54b/artifacts/qydms074_base_logo_transparent_background.png",
  founder: {
    name: "Bablee Tamrakar",
    title: "Director & Founder",
    bio: "With over 15 years of experience in the hospitality industry, Bablee Tamrakar founded Supreme Hospitality Solutions with a vision to transform guest experiences across Australia. Her passion for excellence and deep understanding of hotel operations has helped numerous properties achieve service distinction.",
    image: "https://customer-assets.emergentagent.com/job_c12dcee6-cb25-472a-a8d9-3fec8b95d54b/artifacts/s0m3jen0_file_00000000a9187206a022fa1294c239e2%20%281%29.png"
  },
  contact: {
    email: "Info@supremehospitalitysolutions.com",
    phone: "0457 802 302",
    address: "Melbourne, Victoria, Australia"
  }
};

// Housekeeping images
export const housekeepingImages = {
  hero: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
  making_bed_1: "https://images.pexels.com/photos/9462328/pexels-photo-9462328.jpeg?auto=compress&w=600",
  making_bed_2: "https://images.pexels.com/photos/9462786/pexels-photo-9462786.jpeg?auto=compress&w=600",
  cleaning_room: "https://images.pexels.com/photos/9462341/pexels-photo-9462341.jpeg?auto=compress&w=600",
  housekeeping_cart: "https://images.unsplash.com/photo-1548467323-072c8af90d48?w=600&h=400&fit=crop",
  staff_hallway: "https://images.unsplash.com/photo-1580842402762-6f5868c17412?w=600&h=400&fit=crop",
  hotel_room: "https://images.pexels.com/photos/6466492/pexels-photo-6466492.jpeg?auto=compress&w=600"
};

export const services = [
  {
    id: 1,
    title: "Hotel Housekeeping Services",
    description: "Our core specialty - professional housekeeping teams that maintain immaculate room standards. From bed making to deep cleaning, we ensure every guest walks into perfection.",
    icon: "Sparkles",
    features: ["5-star cleaning protocols", "Expert bed making", "Deep cleaning services", "Turndown service", "Quality inspections", "Eco-friendly products"],
    image: "https://images.pexels.com/photos/9462328/pexels-photo-9462328.jpeg?auto=compress&w=400"
  },
  {
    id: 2,
    title: "Hotel Staffing & Recruitment",
    description: "We provide thoroughly vetted, skilled hospitality professionals ready to deliver excellence from day one. Specializing in housekeeping staff placement.",
    icon: "Users",
    features: ["Rigorous screening process", "Industry-certified professionals", "Flexible staffing solutions", "Rapid deployment"],
    image: "https://images.unsplash.com/photo-1580842402762-6f5468c17412?w=400&h=300&fit=crop"
  },
  {
    id: 3,
    title: "Housekeeping Training",
    description: "Comprehensive training programs designed to elevate your housekeeping team's skills to 5-star international standards.",
    icon: "GraduationCap",
    features: ["Bed making excellence", "Cleaning techniques", "Guest service skills", "Safety & compliance"],
    image: "https://images.pexels.com/photos/9462341/pexels-photo-9462341.jpeg?auto=compress&w=400"
  },
  {
    id: 4,
    title: "Management Consulting",
    description: "Strategic insights and operational expertise to optimize your housekeeping department's efficiency and guest satisfaction.",
    icon: "LineChart",
    features: ["Operational audits", "Staff scheduling", "Cost optimization", "Process improvement"],
    image: "https://images.unsplash.com/photo-1548467323-072c8af90d48?w=400&h=300&fit=crop"
  }
];

export const clients = [
  { id: 1, name: "Accor", logo: "accor" },
  { id: 2, name: "Quest Apartment Hotels", logo: "quest" },
  { id: 3, name: "Boutique Collection", logo: "boutique" },
  { id: 4, name: "IHG Hotels", logo: "ihg" },
  { id: 5, name: "Mantra Group", logo: "mantra" },
  { id: 6, name: "Choice Hotels", logo: "choice" }
];

export const testimonials = [
  {
    id: 1,
    quote: "Supreme Hospitality Solutions transformed our housekeeping operations. Their teams consistently deliver immaculate room presentations that our guests love.",
    author: "",
    role: "General Manager",
    company: "Quest Melbourne CBD",
    rating: 5
  },
  {
    id: 2,
    quote: "The housekeeping training programs are outstanding. Our room inspection scores improved by 40% within three months.",
    author: "",
    role: "Operations Director",
    company: "Boutique Hotels Group",
    rating: 5
  },
  {
    id: 3,
    quote: "Bablee and her team understand hotel housekeeping at its core. Their staff are professional, reliable, and detail-oriented.",
    author: "",
    role: "Hotel Owner",
    company: "Premium Accommodation",
    rating: 5
  }
];

export const stats = [
  { id: 1, value: "200+", label: "Professionals Placed" },
  { id: 2, value: "10+", label: "Hotel Partners" },
  { id: 3, value: "15+", label: "Years Experience" },
  { id: 4, value: "98%", label: "Client Satisfaction" }
];

export const jobListings = [
  {
    id: 1,
    title: "Senior Housekeeper",
    location: "Melbourne CBD",
    type: "Full-time",
    description: "Join our premium housekeeping team at a 5-star property."
  },
  {
    id: 2,
    title: "Room Attendant",
    location: "Sydney",
    type: "Full-time",
    description: "Maintain immaculate room standards at boutique hotel."
  },
  {
    id: 3,
    title: "Housekeeping Supervisor",
    location: "Brisbane",
    type: "Full-time",
    description: "Lead and train housekeeping team members."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Housekeeping Specialists",
    description: "Deep expertise in hotel housekeeping operations and standards."
  },
  {
    id: 2,
    title: "Quality Assurance",
    description: "Rigorous room inspection protocols ensure consistent excellence."
  },
  {
    id: 3,
    title: "Trained Professionals",
    description: "All staff trained to 5-star international housekeeping standards."
  },
  {
    id: 4,
    title: "Proven Results",
    description: "Track record of improving guest satisfaction and room scores."
  }
];
